import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA5cBk-leuFJJJqDi4TEJZMahXH-19ikMU",
  projectId: "ymyd-phai",
  messagingSenderId: "768930474540",
  appId: "1:768930474540:web:57cf0614630382730fbf89",
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

export const getFirebaseApp = (): FirebaseApp => {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
};

export const getFirebaseMessaging = (): Messaging | null => {
  if (!("serviceWorker" in navigator)) {
    return null;
  }
  if (!messaging) {
    messaging = getMessaging(getFirebaseApp());
  }
  return messaging;
};
